import React from "react";
import { useTranslation } from "react-i18next";
import AssessmentBanner from "./components/AssessmentBanner";
import { getAssessmentDefinition } from "./assessmentConfig";

const definition = getAssessmentDefinition("vineland");

interface VinelandBannerProps {
  onClickChartButton: () => void;
  noAssessments?: boolean;
  showSecondaryAction?: boolean;
}

export default function VinelandBanner({
  onClickChartButton,
  noAssessments,
  showSecondaryAction = false,
}: VinelandBannerProps) {
  const { t } = useTranslation(["clientHeader"]);

  const translatedDefinition = {
    ...definition,
    title: t("clientHeader:assessments.vinelandTitle"),
    description: t("clientHeader:assessments.vinelandDescription"),
    primaryActionLabel: t("clientHeader:assessments.viewScores"),
  };

  return (
    <AssessmentBanner
      definition={translatedDefinition}
      onViewScores={onClickChartButton}
      onAddAssessment={() => {}}
      hideActions={noAssessments}
      hideSecondaryAction={!showSecondaryAction}
    />
  );
}
